import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLang } from "../lib/LangContext";
import { waLink, heroImages } from "../lib/mock";

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section
      id="how-it-works"
      className="relative bg-lokam-forest text-lokam-cream overflow-hidden"
    >
      {/* Decorative grain */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #FFFDF9 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Heading column */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-lokam-tangerine">
              {t.how.eyebrow}
            </p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
              {t.how.title}
            </h2>

            <div className="mt-8 rounded-2xl overflow-hidden relative max-w-md">
              <img
                src={heroImages.delivery}
                alt="60 minute delivery"
                className="block w-full h-56 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-lokam-forest via-lokam-forest/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="text-xs uppercase tracking-[0.18em] font-bold text-lokam-tangerine">
                  Delivery starts in
                </div>
                <div className="font-display text-4xl font-bold mt-1">60 minutes.</div>
              </div>
            </div>

            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-lokam-tangerine text-white hover:bg-lokam-tangerine-dark px-5 py-3.5 text-sm font-semibold transition-colors"
            >
              <FaWhatsapp className="h-5 w-5" />
              {t.nav.cta}
            </a>
          </div>

          {/* Steps column */}
          <div className="lg:col-span-7 relative">
            <div className="space-y-6">
              {t.how.steps.map((step, i) => (
                <div
                  key={i}
                  data-testid={`how-step-${i}`}
                  className="relative group flex gap-6 rounded-2xl bg-lokam-forest-soft/40 border border-white/10 p-7 hover:bg-lokam-forest-soft/60 transition-colors"
                  style={{ animationDelay: `${i * 100}ms` }}
                >
                  <div className="flex-shrink-0">
                    <div className="font-display text-5xl font-bold text-lokam-tangerine leading-none">
                      {step.n}
                    </div>
                  </div>
                  <div className="flex-1 pt-1">
                    <div className="font-display text-xl md:text-2xl font-semibold text-lokam-cream leading-tight">
                      {step.title}
                    </div>
                    <p className="mt-2 text-sm md:text-base text-lokam-cream/70 leading-relaxed">
                      {step.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
